import { action_options, app_modules } from "helpers/apps_modules_list";
import ProductQuotationFormV2 from "pages/QuotationV2/Form/index";
import { ServiceQuotationForm as ServiceQuotationFormV2 } from "pages/QuotationV2/Form/index";
import ProductQuotationContainer from "pages/QuotationV2/Listing/Product/ProductQuotationContainer";
import ServiceQuotationContainer from "pages/QuotationV2/Listing/Service/ServiceQuotationContainer";
import ViewProductQuotationV2 from "pages/QuotationV2/View/Product/ViewProductQuotation";
import ViewServiceQuotationV2 from "pages/QuotationV2/View/Service/ViewServiceQuotation";

const QuotationRoutes: any = [
  // Add Form (must be before :tab route to avoid conflicts)
  {
    path: "/quotation/product/add",
    component: <ProductQuotationFormV2 />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.product,
      action: action_options?.create,
    },
  },
  {
    path: "/quotation/service/add",
    component: <ServiceQuotationFormV2 />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.service,
      action: action_options?.create,
    },
  },

  // Edit Form
  {
    path: "/quotation/product/edit/:id",
    component: <ProductQuotationFormV2 />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.product,
      action: action_options?.update,
    },
  },
  {
    path: "/quotation/service/edit/:id",
    component: <ServiceQuotationFormV2 />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.service,
      action: action_options?.update,
    },
  },

  // View Page
  {
    path: "/quotation/product/view/:id",
    component: <ViewProductQuotationV2 />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.product,
      action: action_options?.view,
    },
  },
  {
    path: "/quotation/service/view/:id",
    component: <ViewServiceQuotationV2 />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.service,
      action: action_options?.view,
    },
  },

  // Listing Routes with optional tab parameter (must be last to avoid conflicts with specific routes)
  {
    path: "/quotation/product/:tab?",
    component: <ProductQuotationContainer />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.product,
      action: action_options?.view,
    },
  },
  {
    path: "/quotation/service/:tab?",
    component: <ServiceQuotationContainer />,
    permissions: {
      app_name: app_modules.quotation.app_name,
      module_name: app_modules.quotation.modules.service,
      action: action_options?.view,
    },
  },
];

export default QuotationRoutes;
